export default function HomePage() {
	return <video src="/wayne.mp4" autoPlay loop muted />;
}
